import { gql } from "@apollo/client";

export const USE_INVITE_LINK = gql`
    mutation UseInviteLink($code: String!, $password: String!, $name: String!) {
        useInviteLink(code: $code, password: $password, name: $name) {
            authToken
            email
            id
        }
    }
`;